export default __webpack_public_path__ + "57bcc576fdaf0f5bdb01c6f8e018d404.woff2";